import React from 'react';
import Head from 'next/head';

import { StaticPageLayout } from '../../layouts/static-page.layout';

export const VolumeCalculatorPage = () => (
  <>
    <Head>
      <script src="https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-AMS_HTML" />
    </Head>
    <StaticPageLayout wrapperClassName="wrapper__mini" ns="tools" title="tools.volume.title" text="tools.volume.text" />
  </>
);

VolumeCalculatorPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'tools'],
});

// noinspection JSUnusedGlobalSymbols
export default VolumeCalculatorPage;
